<template>
  <div>
    <div class="help_Info_right fr">
      <div class="help_Info_right_top fl">配送须知</div>
      <div class="help_Info_right_bootm shoppstep fl">
        <dl>
          <dt>配送须知</dt>
          <dd>1)我们将按照订单约定的收件地址、收货人信息发货，并负责将商品送达客户指定的收件地址；</dd>
          <dd>2)客户在订单提交后，若需要变更订单中的收件地址或收货人信息，应在订单出库前与西始取得联系并在双方达成一致的情况下进行地址的变更。如有因客户填写收货信息不准确，或未经西始渠道进行的地址变更，导致商品无法送达的，一切损失由客户承担。</dd>
          <dd>3)由快递配送的订单，按照一般快递配送方式送货上门；由物流配送的订单，物流公司负责送货到点，不上楼，如客户要求送上楼，则由客户直接和物流公司沟通并直接支付上楼费用。</dd>
        </dl>
        <dl>
          <dt>西始将对订单确定的地址提供送货上门配送服务:</dt>
          <dd>同一订单中各项产品若交期不同，您可以选择在最长发货日期同一发货，或按各项产品实际交期分别发货</dd>
          <dd>具体请联系客服专线:400-665-8016</dd>
        </dl>
        <dl>
          <dt>送达时效(按出货日起算)说明:</dt>
          <dd>小件商品、大件商品的送达时效不同；不同地区的送达时效也不同</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "notice"
};
</script>

<style>
</style>
